import React from "react";
import InfoIcon from "@mui/icons-material/Info";
import { Box, IconButton, Tooltip } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Filter from "./Filter";
import CheckBox from "../../../components/CheckBox";
import { ReactComponent as UsersIcon } from "../../../assets/Icons/users.svg";
import { medication_prescriber, psypact } from "../../../constants/common";

const MedicationPrescriberFilter = ({ setFilters, value, filters }) => {
  const handleCheckBox = (ev) => {
    const { name, checked } = ev.target;
    setFilters((prevState) => {
      const updatedState = { ...prevState };
      if (!checked) {
        updatedState[name] = 0;
      } else {
        updatedState[name] = 1;
      }
      return updatedState;
    });
  };

  return (
    <Filter label="Provider Type" icon={<UsersIcon />} expandedDefault>
      <CheckBox
        label={medication_prescriber.label}
        name={medication_prescriber.value}
        value="1"
        onChange={handleCheckBox}
        checked={Boolean(value)}
      />
      <Grid
        item
        xs={12}
        sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
      >
        <CheckBox
          label="PSYPACT"
          name={psypact.value}
          onChange={handleCheckBox}
          checked={Boolean(filters?.psypact_provider)}
        />
        <Tooltip
          arrow
          placement="top"
          title={
            <Typography textAlign="start" variant="body2">
              PSYPACT allows licensed psychologists to provide telehealth and
              short-term in-person care across participating states. Learn more
              at psypact.gov
            </Typography>
          }
        >
          <InfoIcon sx={{ color: "#0C8CE9", fontSize: 16 }} />
        </Tooltip>
      </Grid>
    </Filter>
  );
};

export default MedicationPrescriberFilter;
